export default "__VITE_ASSET__CZjYPXXb__"